import { render, staticRenderFns } from "./drag-resize.vue?vue&type=template&id=2296ee50&scoped=true&"
import script from "./drag-resize.vue?vue&type=script&lang=js&"
export * from "./drag-resize.vue?vue&type=script&lang=js&"
import style0 from "./drag-resize.vue?vue&type=style&index=0&id=2296ee50&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2296ee50",
  null
  
)

export default component.exports